import { MutationTree } from 'vuex';

export const mutations = {
    
};